import type { HubFile } from '@/modules/Workspaces/KnowledgeHub/Hubs/types'
import { nonNullable } from '@/shared/utils/typeAssertions'
import { inject, provide, type InjectionKey, type Ref } from 'vue'

type RowContext = {
  item: Ref<HubFile>
  isHovering: Ref<boolean>
  isUploading?: Ref<boolean>
}

export const rowContextToken = Symbol('hubRowContext') as InjectionKey<RowContext>

export function provideHubRowContext(value: RowContext) {
  provide(rowContextToken, value)
}

export function injectHubRowContext() {
  const context = inject(rowContextToken)
  return nonNullable(context)
}
